import React from 'react';
import cs from 'classnames';
import { RouteLocation } from '../../../stores/routes/createRoute';
import s from './ForYouPageSection.scss';
import { ForYouSectionHeading } from './ForYouSectionHeading/ForYouSectionHeading';
import { forYouPageSectionDataHooks } from './ForYouPageSection.dataHooks';

interface ForYouPageSectionProps {
  dataHook?: string;
  categorySlug?: string;
  expandLink?: RouteLocation;
  isLargePadding?: boolean;
  title: string;
}
export const ForYouPageSection: React.FC<ForYouPageSectionProps> = ({
  dataHook,
  expandLink,
  categorySlug,
  title,
  isLargePadding,
  children,
}) => {
  return (
    <div className={cs(s.root, { [s.largePadding]: isLargePadding })} data-hook={dataHook}>
      <ForYouSectionHeading
        expandLink={expandLink}
        title={title}
        dataHook={forYouPageSectionDataHooks.heading()}
        categorySlug={categorySlug}
      />
      {children}
    </div>
  );
};
